import * as ActionTypes from "../../constants/ActionTypes";

const initialState = {
    // Store appointments (seller's view)
    storeAppointments: [],
    storeAppointmentsLoading: false,
    storeAppointmentsError: null,
    storeAppointmentsPagination: {
        current_page: 1,
        total_pages: 1,
        total_appointments: 0,
        per_page: 10
    },
    
    // Selected appointment (seller's view)
    selectedAppointment: null,
    appointmentDetailsLoading: false,
    appointmentDetailsError: null,
    
    // Actions (confirm, cancel from seller perspective)
    actionLoading: false,
    actionError: null,
    actionSuccess: false,
    
    // Success states for different actions
    confirmSuccess: false,
    cancelSuccess: false,
};

const sellerAppointmentsReducer = (state = initialState, action) => {
    switch (action.type) {
        // Get Store Appointments
        case ActionTypes.GET_STORE_APPOINTMENTS_REQUEST:
            return {
                ...state,
                storeAppointmentsLoading: true,
                storeAppointmentsError: null
            };
            
        case ActionTypes.GET_STORE_APPOINTMENTS_SUCCESS:
            return {
                ...state,
                storeAppointmentsLoading: false,
                storeAppointments: action.payload?.appointments || [],
                storeAppointmentsPagination: action.payload?.pagination || initialState.storeAppointmentsPagination,
                storeAppointmentsError: null
            };
            
        case ActionTypes.GET_STORE_APPOINTMENTS_FAILURE:
            return {
                ...state,
                storeAppointmentsLoading: false,
                storeAppointmentsError: action.payload,
                storeAppointments: []
            };
            
        // Get Appointment Details
        case ActionTypes.GET_APPOINTMENT_DETAILS_REQUEST:
            return {
                ...state,
                appointmentDetailsLoading: true,
                appointmentDetailsError: null
            };
            
        case ActionTypes.GET_APPOINTMENT_DETAILS_SUCCESS:
            return {
                ...state,
                appointmentDetailsLoading: false,
                selectedAppointment: action.payload.appointment || action.payload,
                appointmentDetailsError: null
            };
            
        case ActionTypes.GET_APPOINTMENT_DETAILS_FAILURE:
            return {
                ...state,
                appointmentDetailsLoading: false,
                appointmentDetailsError: action.payload,
                selectedAppointment: null
            };
            
        // Confirm Appointment
        case ActionTypes.SELLER_CONFIRM_APPOINTMENT_REQUEST:
            return {
                ...state,
                actionLoading: true,
                actionError: null,
                actionSuccess: false,
                confirmSuccess: false
            };
            
        case ActionTypes.SELLER_CONFIRM_APPOINTMENT_SUCCESS:
            return {
                ...state,
                actionLoading: false,
                actionSuccess: true,
                confirmSuccess: true,
                actionError: null,
                // Update the appointment in the list if it exists
                storeAppointments: state.storeAppointments.map(appointment =>
                    appointment._id === action.payload.appointment?._id || appointment._id === action.payload._id
                        ? { ...appointment, ...action.payload.appointment || action.payload }
                        : appointment
                )
            };
            
        case ActionTypes.SELLER_CONFIRM_APPOINTMENT_FAILURE:
            return {
                ...state,
                actionLoading: false,
                actionError: action.payload,
                actionSuccess: false,
                confirmSuccess: false
            };
            
        // Cancel Appointment
        case ActionTypes.SELLER_CANCEL_APPOINTMENT_REQUEST:
            return {
                ...state,
                actionLoading: true,
                actionError: null,
                actionSuccess: false,
                cancelSuccess: false
            };
            
        case ActionTypes.SELLER_CANCEL_APPOINTMENT_SUCCESS:
            return {
                ...state,
                actionLoading: false,
                actionSuccess: true,
                cancelSuccess: true,
                actionError: null,
                // Update the appointment in the list if it exists
                storeAppointments: state.storeAppointments.map(appointment =>
                    appointment._id === action.payload.appointment?._id || appointment._id === action.payload._id
                        ? { ...appointment, ...action.payload.appointment || action.payload }
                        : appointment
                )
            };
            
        case ActionTypes.SELLER_CANCEL_APPOINTMENT_FAILURE:
            return {
                ...state,
                actionLoading: false,
                actionError: action.payload,
                actionSuccess: false,
                cancelSuccess: false
            };
            
        // Clear errors and success states
        case ActionTypes.CLEAR_APPOINTMENT_ERRORS:
            return {
                ...state,
                storeAppointmentsError: null,
                appointmentDetailsError: null,
                actionError: null
            };
            
        case ActionTypes.CLEAR_APPOINTMENT_SUCCESS:
            return {
                ...state,
                actionSuccess: false,
                confirmSuccess: false,
                cancelSuccess: false
            };
            
        default:
            return state;
    }
};

export default sellerAppointmentsReducer;
